/**
 * T097: useCreateTag Hook
 * Mutation hook for creating tags
 */

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createTag, type CreateTagInput } from '@/services/tags'
import { queryKeys } from '@/lib/query-keys'

export function useCreateTag() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: CreateTagInput) => createTag(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tags.all })
    },
  })
}
